<p>
  register works!
</p>
